var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { CFAvatarElements } from './Avatar.styles';
import { commonAttrs } from '../../utils';
export const CFAvatar = (_a) => {
    var { backgroundColor, border, colorway = 'default', imageSource, initials, initialsColor, shape = 'circle', size = 'md' } = _a, rest = __rest(_a, ["backgroundColor", "border", "colorway", "imageSource", "initials", "initialsColor", "shape", "size"]);
    const { Root, Image, ImageWeb, Initials } = CFAvatarElements;
    return (React.createElement(Root, Object.assign({ role: 'presentation', "$backgroundColor": backgroundColor, "$border": border, "$colorway": colorway, "$shape": shape, "$size": size }, commonAttrs(rest)),
        React.createElement(Initials, { "$colorway": colorway, "$initialsColor": initialsColor, "$size": size }, initials === null || initials === void 0 ? void 0 : initials.substring(0, 2)),
        imageSource && (React.createElement(Image, null,
            React.createElement(ImageWeb, { src: imageSource, alt: 'Avatar image' })))));
};
